export const GoogleLogo = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9998 10.1778C17.9998 9.52001 17.9453 9.04001 17.8275 8.54224H10.1631V11.5111H14.6619C14.5712 12.2489 14.0814 13.36 12.993 14.1067L12.9777 14.206L15.4011 16.0458L15.569 16.0623C17.1109 14.6667 17.9998 12.6133 17.9998 10.1778Z"
      fill="#4285F4"
    />
    <path
      d="M10.1631 18.0001C12.3672 18.0001 14.2175 17.2889 15.569 16.0623L12.993 14.1067C12.3037 14.5778 11.3785 14.9067 10.1631 14.9067C8.00441 14.9067 6.17223 13.5112 5.51911 11.5823L5.42338 11.5902L2.90356 13.5014L2.87061 13.5911C4.21299 16.2045 6.97036 18.0001 10.1631 18.0001Z"
      fill="#34A853"
    />
    <path
      d="M5.51923 11.5822C5.34689 11.0844 5.24716 10.551 5.24716 9.99995C5.24716 9.4488 5.34689 8.91548 5.51016 8.41771L5.50559 8.3117L2.9542 6.36987L2.87072 6.40879C2.31746 7.49325 2 8.71106 2 9.99995C2 11.2888 2.31746 12.5066 2.87072 13.591L5.51923 11.5822Z"
      fill="#FBBC05"
    />
    <path
      d="M10.1631 5.09333C11.696 5.09333 12.73 5.74222 13.3195 6.28448L15.6234 4.08001C14.2085 2.79112 12.3672 2 10.1631 2C6.97036 2 4.21299 3.79555 2.87061 6.40888L5.51004 8.4178C6.17223 6.48891 8.00441 5.09333 10.1631 5.09333Z"
      fill="#EB4335"
    />
  </svg>
)

export const FacebookLogo = () => (
  <svg
    version="1.1"
    id="svg2"
    width="20"
    height="20"
    viewBox="0 0 1365.3333 1365.3333"
  >
    <g transform="matrix(1.3333333,0,0,-1.3333333,0,1365.3333)">
      <g id="g12" transform="scale(0.1)">
        <path
          d="m 10240,5120 c 0,2827.7 -2292.3,5120 -5120,5120 C 2292.3,10240 0,7947.7 0,5120 0,2564.46 1872.31,446.301 4320,62.1992 V 3640 H 3020 v 1480 h 1300 v 1128 c 0,1283.2 764.38,1992 1933.9,1992 560.17,0 1146.1,-100 1146.1,-100 V 6880 H 6754.38 C 6118.35,6880 5920,6485.33 5920,6080.43 V 5120 H 7340 L 7113,3640 H 5920 V 62.1992 C 8367.69,446.301 10240,2564.46 10240,5120"
          style={{
            fill: '#1877f2',
            fillOpacity: 1,
            fillRule: 'nonzero',
            stroke: 'none',
          }}
          id="path14"
        />
        <path
          d="m 7113,3640 227,1480 H 5920 v 960.43 c 0,404.9 198.35,799.57 834.38,799.57 H 7400 v 1260 c 0,0 -585.93,100 -1146.1,100 C 5084.38,8240 4320,7531.2 4320,6248 V 5120 H 3020 V 3640 H 4320 V 62.1992 C 4580.67,21.3008 4847.84,0 5120,0 c 272.16,0 539.33,21.3008 800,62.1992 V 3640 h 1193"
          style={{
            fill: '#ffffff',
            fillOpacity: 1,
            fillRule: 'nonzero',
            stroke: 'none',
          }}
          id="path16"
        />
      </g>
    </g>
  </svg>
)

export const LinkedInLogo = () => {
  return (
    <svg
      height="20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
    >
      <g fill="none">
        <path
          d="M0 18.338C0 8.216 8.474 0 18.92 0h218.16C247.53 0 256 8.216 256 18.338v219.327C256 247.79 247.53 256 237.08 256H18.92C8.475 256 0 247.791 0 237.668V18.335z"
          fill="#069"
        />
        <path
          d="M77.796 214.238V98.986H39.488v115.252H77.8zM58.65 83.253c13.356 0 21.671-8.85 21.671-19.91-.25-11.312-8.315-19.915-21.417-19.915-13.111 0-21.674 8.603-21.674 19.914 0 11.06 8.312 19.91 21.169 19.91h.248zM99 214.238h38.305v-64.355c0-3.44.25-6.889 1.262-9.346 2.768-6.885 9.071-14.012 19.656-14.012 13.858 0 19.405 10.568 19.405 26.063v61.65h38.304v-66.082c0-35.399-18.896-51.872-44.099-51.872-20.663 0-29.738 11.549-34.78 19.415h.255V98.99H99.002c.5 10.812-.003 115.252-.003 115.252z"
          fill="#fff"
        />
      </g>
    </svg>
  )
}
